
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class LocationTransferDialog extends _Ext.TransDialog<LocationTransferRow, any> {

        protected getFormKey() { return LocationTransferForm.formKey; }
        protected getIdProperty() { return LocationTransferRow.idProperty; }
        protected getLocalTextPrefix() { return LocationTransferRow.localTextPrefix; }
        protected getNameProperty() { return LocationTransferRow.nameProperty; }
        protected getService() { return LocationTransferService.baseUrl; }
        protected getDeletePermission() { return LocationTransferRow.deletePermission; }
        protected getInsertPermission() { return LocationTransferRow.insertPermission; }
        protected getUpdatePermission() { return LocationTransferRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new LocationTransferForm(this.idPrefix); 
        TaxArray: any[]; 
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.HideCategoryLable(this.element);
            q.hideCategorylinks(this.element);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Pieces);
            //q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.VoucherTypeId);
            q.SetCategoryFullWidth(this.form.ItemDetails);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
           
            this.form.FromDepartmentId.changeSelect2(e => {
                this.form.ItemDetails.DeptId = parseInt(this.form.FromDepartmentId.value);

                if (this.form.FromDepartmentId.value == this.form.ToDepartmentId.value) {
                    Q.notifyError("From and To Departments cannot be same");
                    Serenity.EditorUtils.setValue(this.form.FromDepartmentId, "");
                }
            });

            this.form.ToDepartmentId.changeSelect2(e => {
                // this.form.ItemDetails.DeptId = parseInt(this.form.FromDepartmentId.value);

                if (this.form.FromDepartmentId.value == this.form.ToDepartmentId.value) {
                    Q.notifyError("From and To Departments cannot be same");
                    Serenity.EditorUtils.setValue(this.form.ToDepartmentId, "");
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                this.ExchangeRate = ExchangeDetails.ExchRate;

            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();
                    Items = this.form.ItemDetails.getItems();

                    var TotalItems = this.form.ItemDetails.getTotalRows();
                    if (ItemTotal > 0) {
                        ItemTotal = 0;
                    }

                    if (Items.length == TotalItems) {

                        this.CalculateAmountandTax(Items );
                    }
                }); 


            this.form.Pieces.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();

        } 


        public CalculateAmountandTax(Items: any) {

             var gramt = 0; var disc = 0; var wt = 0; var pcs = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                nwt += x.NetWeight|| 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0; 
            };

            this.form.Pieces.value = pcs;
            this.form.Weight.value = wt;
            this.form.NetWeight.value = nwt;



            this.form.ItemDetails.render;
        }


        protected onDialogOpen() {
            super.onDialogOpen();

            //this.form.ItemDetails.parentDialog = this;
            if (this.isNew) {
                if (this.form.FromDepartmentId.value == "") {
                    this.form.Pieces.value = 0;
                    this.form.ItemDetails.DepartmentId = parseInt(this.form.FromDepartmentId.value);

                }

            }
            if (this.form.FromDepartmentId.value != "") {
                this.form.ItemDetails.DeptId = parseInt(this.form.FromDepartmentId.value);
                this.form.Pieces.value = 0;
            }

            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
            }
        
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Inventory.LocationTransferVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Inventory:LocationTransfer:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    LocationTransferService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                LocationTransferService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        } 
        validateEntity(row: LocationTransferRow, id: number) {
            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                return false;
            }
            for (var i = 0; i < row.ItemDetails.length; i++) {
                row.ItemDetails[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        Q.alert("Rate not Defined for Component, Can not Save!")
                        return false;
                    }
                })

            }

            return true;
        } 
    }
}